import { SetterGetter } from "./pivot-controls.js";

const zeroVector = new THREE.Vector3();

class SetterGetterQ3Data extends SetterGetter {
    constructor(q3data) {
        super();

        this._data = q3data;
    }

    setObjectPivot(object, pivot) {
        const objectData = this._data.assets.objects[object.uuid];

        if (!objectData) {
            throw new Error("Object data not found");
        }

        let dataPivot = objectData.pivot;

        if (pivot) {
            if (!dataPivot) {
                dataPivot = {};
                objectData.pivot = dataPivot;
            }

            dataPivot.x = pivot.x;
            dataPivot.y = pivot.y;
            dataPivot.z = pivot.z;
        } else {
            if (dataPivot) {
                delete objectData.pivot;
            }
        }
    }

    getObjectPivot(object, pivot = new THREE.Vector3()) {
        const objectData = this._data.assets.objects[object.uuid];

        if (!objectData) {
            throw new Error("Object data not found");
        }

        return pivot.copy(objectData.pivot || zeroVector);
    }
}

export default SetterGetterQ3Data;
